<script>
import Checkbox from 'vue-material-checkbox'

const DEFAULT_PRODUCT_IMAGE = 'emptystate.png'

const PRODUCT_TYPE = {
  REMOVAL: 'removal',
  NORMAL: 'normal',
  WHIM: 'whim',
  SUBSTITUTE: 'substitution'
};

export default {
  name: 'OrderProduct',
  components: {
    Checkbox,
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    disabled: {
      default: false,
      type: Boolean,
      required: false
    },
    selectable: {
      type: Boolean,
      required: true
    },
    background: {
      default: false,
      type: Boolean,
      required: false
    },
    last: {
      default: false,
      type: Boolean,
      required: false
    },
    freshness: {
      default: false,
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      showSubstitute: false,
      checkbox: false,
      complainedUnits: 1,
      quantity: 1,
      selectedProduct: {}
    }
  },
  computed: {
    computedProduct() {
     return this.checkbox ? Object.assign({}, this.selectedProduct, {
       complainedUnits: this.complainedUnits,
          quantity: this.quantity,
          product_compensation_type: 'product',
          include: true,
     }) : Object.assign({}, this.product, {
          include: false,
        })
    }
    ,
    unitText() {
      return this.product.units > 1 ? this.$t('COMPONENTS.ORDER_PRODUCT.UNITS') : this.$t('COMPONENTS.ORDER_PRODUCT.UNIT')
    },
    substituted() {
      return this.product.substitution && this.product.substitution.substituted;
    },
    substituteToggleLabel() {
      return this.showSubstitute ? this.$t('COMPONENTS.ORDER_PRODUCT.HIDE') : this.$t('COMPONENTS.ORDER_PRODUCT.SHOW');
    },
    showToggle() {
      return !this.disabled && this.product.substitution;
    }
  },
  watch: {
    checkbox() {
      this.selectedProduct = this.checkbox
      ? Object.assign({}, this.product)
      : null
      this.updateProduct();
    },
    complainedUnits() {
      this.updateProduct();
    }
  },
  methods: {
    toggle() {
      this.showSubstitute = !this.showSubstitute;
    },
    productTitleClass() {
      switch (this.product.product_type) {
        case PRODUCT_TYPE.WHIM:
          return this.$style.container__productTypeWhim;
        case PRODUCT_TYPE.SUBSTITUTE:
          return this.$style.container__productTypeNormal;
        case PRODUCT_TYPE.REMOVAL:
          return this.$style.container__productTypeDeleted;
        default:
          return this.$style.container__productTypeReplaced;
      }
    },
    showBackground() {
      return this.background ? this.$style.container__background : '';
    },
    imageUrlAlt(event) {
      const image = require.context('@assets/images/', false, /\.png$/)
      event.target.src = image(`./${DEFAULT_PRODUCT_IMAGE}`)
    },
    showSeparator() {
      return !this.last ? this.$style.container__separator : '';
    },
    selectionChange() {
      this.productChecked = { data: this.product, checked: this.checkbox };
      this.$emit('productChecked', this.productChecked);
    },
    updateProduct() {

      this.productChecked = {data: this.computedProduct, checked: this.checkbox}

      this.$emit('productChecked', this.productChecked);
    },
    increaseUnits() {
      if(this.complainedUnits < this.product.units) {
        this.complainedUnits++;
      }
    },
    decreaseUnits(){
      if (this.complainedUnits > 1 ){
        this.complainedUnits--;
      }
    }
  }
}
</script>

<template>
  <div :class="[$style.container, showBackground()]">
    <div
      v-if="disabled"
      :class="$style.container__backdrop" />
    <div :class="$style.container__product">
      <div :class="$style.container__imgWrapper">
        <img
          :class="$style.container__image"
          :src="product.image"
          :alt="product.description"
          @error="imageUrlAlt"
        >
      </div>

      <div :class="$style.container__details">
        <span
          :class="[productTitleClass(), $style.container__availability]">
          {{ product.title }}
        </span>
        <div :class="$style.container__info">
          <div :class="$style.container__infoDetails">
            <p :class="[$style.container__text, $style.container__textTitle]">{{ product.name }}</p>
            <p :class="[$style.container__text, $style.container__textUnit]">{{ `${ product.units } ${ unitText }` }}</p>
            <p :class="$style.container__text">${{ product.total_price }}</p>
          </div>
          <div :class="$style.container__last">
            <v-checkbox
              v-if="selectable && freshness"
              :class="$style.container__checkbox"
              v-model="checkbox"
              color="#332926"
            />
            <div
              v-if="showToggle"
              :class="$style.container__toggle"
              @click="toggle()"
            >
              <button>{{ substituteToggleLabel }}</button>
              <img
                alt="check"
                src="@assets/images/expand_more.svg"
              >
            </div>
          </div>
        </div>
        <div :class="$style.container__toppings">
          <ul>
            <li
              v-for="(topping, i) in product.toppings"
              :key="i">
              <span
                v-if="freshness"
                :class="$style.container__toppings__freshness"> Madurez:
                <span>{{ topping }}</span>
              </span>
              <span v-if="!freshness">{{ topping }}</span>
            </li>
          </ul>
        </div>

        <div
          v-if="(product.units > 1) && freshness && selectable"
          :class="$style.container__counter">
          <div :class="$style.container__counter__units">
            <button
              @click="decreaseUnits"
            >
              -
            </button>
            <div :class="$style.container__units__text">
              {{ complainedUnits }}
            </div>
            <button
              @click="increaseUnits"
            >+</button>
          </div>
        </div>
        <div
          :class="[showSeparator()]"/>

      </div>
    </div>

    <OrderProduct
      v-if="showSubstitute"
      :product="substituted"
      :disabled="true"
      :selectable="false"
      :background="true"
    />


  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  position: relative;
  display: flex;
  flex-direction: column;

  &__background {
    background-color: #dcdada;
  }

  &__backdrop {
    position: absolute;
    z-index: 1000;
    width: 100%;
    height: 110px;
    background-color: #f9f9f8;
    opacity: 0.4;
  }

  &__product {
    display: flex;
    justify-content: flex-start;
    max-height: 100%;
    margin: 1rem 0 0 1rem;
  }

  &__imgWrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 5rem;
    min-width: 20%;
    height: 5rem;
  }

  &__image {
    max-width: 100%;
    max-height: 100%;
    border-radius: 10px;
  }

  &__details {
    display: flex;
    flex-direction: column;
    width: 75%;
  }

  &__availability {
    align-self: flex-start;
    margin-left: 1rem;
  }

  &__info {
    display: flex;
    min-height: 5rem;
    max-height: 6rem;
    margin-left: 1rem;
    text-align: left;
  }

  &__separator {
    border-bottom: solid 1px #e5e5e4;
    padding-bottom: .5rem;
  }

  &__infoDetails {
    justify-content: space-around;
    width: 80%;
    margin-top: .1rem;
  }

  &__text {
    @extend %typography-small;

    margin: 0 0 5px 0;
    color: $color-heading-text;

    &:not(:nth-child(1)) {
      margin: 0 0 10px 0;
    }

    &Title {
      overflow: hidden;
      font-size: 1.1rem;
      font-weight: bold;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &Unit {
      color: $secondary-text;
      margin-top: -5px !important;
    }
  }

  &__counter {
    display: flex;
    flex-flow: column wrap;
    justify-content: center;
    align-items: flex-start;
    padding: 0 1rem;

    &__units {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: space-between;
    height: 2rem;
    width: 5rem;
    padding: 0 .5rem;
    border: 1px solid $divider-gray;
    border-radius: 5px;
    box-shadow: $regular-box-shadow;
    font-weight: bold;

    button {
      &:focus {
        outline: 0;
      }
    }

    &__text {
      @extend %typography-small;

      margin: 0 !important;
      text-align: center;
      font-weight: bold;

      @include responsive(phone) {
        font-size: 1rem;
      }

      span {
        color: $blue-gray;
      }
    }
  }
}



  &__productType {
    &Whim, &Normal {
      color: $green-success;
    }

    &Replaced {
      color: $orange-alert;
    }

    &Deleted {
      color: $orange-primary;
    }
  }

  &__last {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: flex-end;
    width: 20%;
    margin-bottom: 5px;
    height: 100%;
  }

  &__checkbox {
    align-self: flex-end;
    margin: 0 0 13px 0;
    direction: rtl;
    width: 20px;
    height: 20px;
  }

  &__toggle {
    display: flex;
    align-items: flex-end;
    line-height: 30px;

    button {
      outline: none;
    }
  }

  &__toppings {
    align-self: flex-start;
    margin-left: 1rem;

    &__freshness {
      color: $secondary-text;

      span {
        font-weight: bold;
      }
    }

    ul {
      padding: 0;
      list-style: none;
    }
    li {
      text-align: left;

      &::before {
        vertical-align: super;
        content: '.';
      }

      &:last-child {
        margin-bottom: 6px;
      }
    }
  }
}


</style>
